import React from 'react';
import { colors } from '../constants/colors';

/**
 * Read-only star rating row (★★★☆☆ + optional count).
 * Extracted from ChamomileApp.jsx (monolith break-up, Aug 2026) — shared by
 * ProductCard, the review form header and the product reviews modal.
 */
const StarRating = ({ rating, count, size = 14, showCount = true, onClick }) => {
  const fullStars = Math.floor(rating);
  const hasHalf = rating - fullStars >= 0.5;

  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'opacity 0.2s ease',
      }}
      className={onClick ? 'star-rating-clickable' : ''}
    >
      <div style={{ display: 'flex', gap: '1px' }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            style={{
              color: star <= fullStars ? colors.gold500 : (star === fullStars + 1 && hasHalf ? colors.gold500 : colors.stone300),
              fontSize: `${size}px`,
              lineHeight: 1,
            }}
          >
            {star <= fullStars ? '★' : (star === fullStars + 1 && hasHalf ? '★' : '☆')}
          </span>
        ))}
      </div>
      {showCount && count !== undefined && (
        <span style={{ fontSize: '11px', color: colors.stone400 }}>
          ({count})
        </span>
      )}
    </div>
  );
};

export default StarRating;
